import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.button = this.el.querySelector('.js-button-play');
        this.placeholder = this.el.querySelector('.js-placeholder');
        this.video = this.el.dataset.video;

        if (this.button) {
            this.button.addEventListener('click', () => {
                this.placeholder.remove();
                this.el.insertAdjacentHTML('beforeend', `${this.video}`);
            });
        }
    }
}